import React from 'react'

import { SwitchInput, SwitchLabel, SwitchButton } from './style'

const Switch = ({ id, toggled, onChange}) => {

  const toggleSwitch = (ev) => {
    onChange(ev.target.checked)
  }

  return (
    <>
      <SwitchInput
        id={id}
        type="checkbox"
        checked={toggled}
        onChange={toggleSwitch}
        data-testid='test-switch-input'
      />
      <SwitchLabel enable={toggled ? 'enable' : ''} htmlFor={id} data-testid='test-switch-label'>
        <SwitchButton />
      </SwitchLabel>
    </>
  )
}

export default Switch
